import { render, staticRenderFns } from "./BeSave.vue?vue&type=template&id=dd580fec&scoped=true"
import script from "./BeSave.vue?vue&type=script&lang=js"
export * from "./BeSave.vue?vue&type=script&lang=js"
import style0 from "./BeSave.vue?vue&type=style&index=0&id=dd580fec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd580fec",
  null
  
)

export default component.exports